import React, { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Stack from '@mui/material/Stack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { CgIfDesign } from 'react-icons/cg'
import { MdOutlineDisplaySettings } from 'react-icons/md'
import { ImProfile } from 'react-icons/im'
import defaultTexts from '../../texts/texts'
import constants from '../../config/constants'
import useWindowDimensions from '../_common/WindowDimesnions'
import { publicRequest } from '../../_network/request'
import { subscriptionsURLs } from '../../_network/apiUrls'
import admin_ui_screenshot from '../../assets/images/admin_ui_screenshot.png'
import customer_ui_screenshot from '../../assets/images/customer_ui_screenshot.png'
import billing_screenshot from '../../assets/images/billing_screenshot.png'
import home_banner_billing from '../../assets/images/home_banner_billing.png'
import parse from 'html-react-parser'
import CustomHomeDivider from '../_common/CustomHomeDivider'
import HomeSubscriptionItem from './HomeSubscriptionItem'
import CustomSlickSlider from '../_common/CustomSlickSlider'

const HomeProductOpenStack = () => {
  const theme = useTheme()
  const { width } = useWindowDimensions()

  const [subscriptionPackagesData, setSubscriptionPackagesData] = useState([])
  const [subscriptionGroupsData, setSubscriptionGroupsData] = useState([])
  const [subscriptions, setSubscriptions] = useState([])
  const [subscriptionsSliderData, setSubscriptionsSliderData] = useState([])
  const [subscriptionsSliderSlidesToShow, setSubscriptionsSliderSlidesToShow] = useState(0)

  const subscriptionSliderArrows = {
    leftIcon: <ArrowBackIcon fontSize='large' />,
    rightIcon: <ArrowForwardIcon fontSize='large' />,
    leftStyle: {
      width: '50px',
      height: '50px',
      border: `${theme.palette.oxfordBlue} 2px solid`,
      borderRadius: '25px',
      color: theme.palette.oxfordBlue,
      position: 'absolute',
      top: '45%',
      left: '-50px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },    
    rightStyle: {
      width: '50px',
      height: '50px',
      border: `${theme.palette.oxfordBlue} 2px solid`,
      borderRadius: '25px',
      color: theme.palette.oxfordBlue,
      position: 'absolute',
      top: '45%',
      right: '-50px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }

  const pageLabelStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '28px',
    fontWeight: '500',
  }

  const adminUiWrapperStyle = {
    minHeight: '500px',
    background: theme.palette.aliceBlue,
    padding: '20px',
    borderTop: `${theme.palette.vodka} 1px solid`,
  }

  const imageStyle = {
    maxWidth: '100%',
    height: 'auto',
  }

  const adminUiLabel = {
    color: theme.palette.violetsAreBlue,
    paddingBottom: '30px',
    fontWeight: '500',
    fontSize: '22px',
  }

  const adminUiDescription = {
    fontSize: '20px',
  }

  const customerUiWrapperStyle = {
    minHeight: '500px',
    background: theme.palette.oxfordBlue,
    padding: '20px',
  }

  const customerUiDescription = {
    fontSize: '20px',
    color: 'white',
  }

  const featuresWrapperStyle = {
    minHeight: '600px',
    background: theme.palette.violetsAreBlue,
    padding: '20px 5%',
  }

  const featuresLabelStyle = {
    fontSize: '32px',
    color: theme.palette.oxfordBlue,
    padding: '10px 0px 40px 0px',
    textAlign: 'center',
    fontWeight: '500',
  }

  const featuresIconStyle = {
    width: '100px',
    height: '100px',
    border: '#FFFFFF 4px solid',
    borderRadius: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const featuresDescriptionStyle = {
    color: 'white',
    fontSize: width >= constants.lgBreakpoint ? '24px' : '20px',
    fontWeight: '500',
  }

  const bannerBillingStyle = {
    minHeight: width >= constants.mdBreakpoint ? '460px' : 'initial',
    background: `url(${home_banner_billing}) no-repeat center / cover`,
    padding: '0px 5%',
    color: 'white',
  }

  const bannerBillingLabel = {
    fontSize: width >= constants.lgBreakpoint ? '32px' : '26px',
    fontWeight: '500',
    color: width >= constants.mdBreakpoint ? theme.palette.violetsAreBlue : 'white',
    paddingTop: width >= constants.mdBreakpoint ? '0px' : '20px',
  }

  const bannerBillingDescription = {
    fontSize: width >= constants.lgBreakpoint ? '24px' : '20px',
    fontWeight: '500',
    paddingBottom: width >= constants.mdBreakpoint ? '0px' : '40px',
  }

  const pricesLabel = {
    height: '100px',
    background: 'white',
    fontSize: '40px',
    color: theme.palette.violetsAreBlue,
    position: 'absolute',
    top: '0px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px 5%',
  }

  const pricesWrapperStyle = {
    background: theme.palette.aliceBlue,
    padding: '30px 20px 30px 20px',
  }

  const pricesLabelStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '32px',
    fontWeight: '500',
    textAlign: 'center',
    padding: '0px 0px 30px 0px',
  }

  useEffect(() => {
    const fetchSubscriptionPackagesData = async () => {
      const url = constants.core_service_domain + '/' + subscriptionsURLs.getSubscriptionPackages
      
      const request_data = { url, method: 'GET' }
      
      const response = await publicRequest(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setSubscriptionPackagesData(response.data.filter(item => item.group === 'openstack_admin'))
      } else {
        setSubscriptionPackagesData([])
      }
    }

    const fetchSubscriptionGroupsData = async () => {
      const url = constants.core_service_domain + '/' + subscriptionsURLs.getSubscriptionGroups
      
      const request_data = { url, method: 'GET' }
      
      const response = await publicRequest(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setSubscriptionGroupsData(response.data)
      } else {
        setSubscriptionGroupsData([])
      }
    }

    fetchSubscriptionPackagesData()
    fetchSubscriptionGroupsData()
  }, [])

  useEffect(() => {
    const sortByPriority = (list) => {
      return [...list].sort((a, b) => a.priority - b.priority)
    }

    const getSortedSubscriptions = () => {
      let result = []

      const groups = sortByPriority(subscriptionGroupsData)

      groups.forEach(gr => {
        const filtered_packages = subscriptionPackagesData.filter(pa => pa.group === gr.group_name)
        const sorted_packages = filtered_packages.length > 0 ? sortByPriority(filtered_packages) : []
        sorted_packages.forEach(pa => [
          result.push({
            ...pa,
            group_name: gr.title.value,
          })
        ])
      })

      return result
    }

    if (subscriptionPackagesData.length > 0 && subscriptionGroupsData.length > 0) {
      const sorted_subscriptions = getSortedSubscriptions()
      setSubscriptions(sorted_subscriptions)
    } else {
      setSubscriptions([])
    }
  }, [subscriptionPackagesData, subscriptionGroupsData])

  useEffect(() => {
    if (subscriptions.length > 0) {
      let subscription_slider_data = []

      subscriptions.forEach((item, index) => {
        subscription_slider_data.push(<HomeSubscriptionItem
          key={index}
          index={index}
          {...item}
        />)
      })

      setSubscriptionsSliderData(subscription_slider_data)

      let slides_to_show = 3

      if (width < constants.mdBreakpoint) {
        slides_to_show = 1
      } else if (width < constants.lgBreakpoint) {
        slides_to_show = 2
      } else if (subscriptions.length < 3) {
        slides_to_show = subscriptions.length
      }

      setSubscriptionsSliderSlidesToShow(slides_to_show)
    } else {
      setSubscriptionsSliderData([])
      setSubscriptionsSliderSlidesToShow(0)
    }
  }, [subscriptions, width])

  const getAdminUiScreenshot = () => {
    return (
      <Grid size={{ xs: 12, lg: 7, xl: 5 }}>
        <Box>
          <Stack
            direction='column'
            alignItems={{ xs: 'center', lg: 'flex-start' }}
            justifyContent='center'
            sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
          >
            <Box>
              <img src={admin_ui_screenshot} alt='' style={imageStyle} />
            </Box>
          </Stack>              
        </Box>
      </Grid>
    )
  }

  const getBillingScreenshot = () => {
    return (
      <Grid size={{ xs: 12, lg: 7, xl: 5 }}>
        <Box>
          <Stack
            direction='column'
            alignItems={{ xs: 'center', lg: 'flex-start' }}
            justifyContent='center'
            sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
          >
            <Box>
              <img src={billing_screenshot} alt='' style={imageStyle} />
            </Box>
          </Stack>              
        </Box>
      </Grid>
    )
  }
  
  return (
    <>
      <Box sx={adminUiWrapperStyle} id='id_products'>
        <Box sx={pageLabelStyle}>{defaultTexts.openStackSolutionKit}</Box>
        <Grid container spacing={ width >= constants.lgBreakpoint ? 12 : 4 }>
          { width >= constants.lgBreakpoint && getAdminUiScreenshot() }
          <Grid size={{ xs: 12, lg: 5, xl: 6 }}>
            <Box>
              <Stack
                direction='column'
                alignItems='flex-start'
                justifyContent='center'
                sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
              >
                <Box sx={adminUiLabel}>{defaultTexts.openStackAdminUi}</Box>
                <Box sx={adminUiDescription}>{parse(defaultTexts.openStackAdminUiText)}</Box>
              </Stack>
            </Box>
          </Grid>
          { width < constants.lgBreakpoint && getAdminUiScreenshot() }
        </Grid>
      </Box>

      <Box sx={customerUiWrapperStyle}>
        <Grid container spacing={ width >= constants.lgBreakpoint ? 12 : 4 }>
          <Grid size={{ xs: 12, lg: 5, xl: 5 }} offset={{ xs: 0, xl: 1 }}>
            <Box>
              <Stack
                direction='column'
                alignItems='flex-start'
                justifyContent='center'
                sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
              >
                <Box sx={adminUiLabel}>{defaultTexts.openStackCustomerUi}</Box>
                <Box sx={customerUiDescription}>{parse(defaultTexts.openStackCustomerUiText)}</Box>
              </Stack>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, lg: 7, xl: 6 }}>
            <Box>
              <Stack
                direction='column'
                alignItems={{ xs: 'center', lg: 'flex-start' }}
                justifyContent='center'
                sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
              >
                <Box>
                  <img src={customer_ui_screenshot} alt='' style={imageStyle} />
                </Box>
              </Stack>              
            </Box>
          </Grid> 
        </Grid>
      </Box>

      <Box sx={adminUiWrapperStyle}>
        <Grid container spacing={ width >= constants.lgBreakpoint ? 12 : 4 }>
          { width >= constants.lgBreakpoint && getBillingScreenshot() }
          <Grid size={{ xs: 12, lg: 5, xl: 6 }}>
            <Box>
              <Stack
                direction='column'
                alignItems='flex-start'
                justifyContent='center'
                sx={{ minHeight: width >= constants.lgBreakpoint ? '500px' : 'initial' }}
              >
                <Box sx={adminUiLabel}>{defaultTexts.openStackBilling}</Box>
                <Box sx={adminUiDescription}>{parse(defaultTexts.openStackBillingText)}</Box>
              </Stack>
            </Box>
          </Grid>
          { width < constants.lgBreakpoint && getBillingScreenshot() }
        </Grid>
      </Box>

      <Box sx={featuresWrapperStyle} id='id_features'>
        <Box sx={featuresLabelStyle}>{defaultTexts.customizableUserInterfaces}</Box>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems='flex-start'
          justifyContent='space-around'
          spacing={ width >= constants.lgBreakpoint ? 12 : 4 }
          sx={{ width: '100%' }}
        >
          <Box sx={{ flex: 1 }}>
            <Stack
              direction='column'
              alignItems='center'
              justifyContent='flex-start'
              spacing={6}
            >
              <Box sx={featuresIconStyle}>
                <CgIfDesign color='white' size='90' />   
              </Box>
              <Box sx={featuresDescriptionStyle}>{defaultTexts.customizableUserInterfacesText1}</Box>
            </Stack>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Stack
              direction='column'
              alignItems='center'
              justifyContent='flex-start'
              spacing={6}
            >
              <Box sx={featuresIconStyle}>
                <MdOutlineDisplaySettings color='white' size='78' />   
              </Box>
              <Box sx={featuresDescriptionStyle}>{defaultTexts.customizableUserInterfacesText2}</Box>
            </Stack>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Stack
              direction='column'
              alignItems='center'
              justifyContent='flex-start'
              spacing={6}
            >
              <Box sx={featuresIconStyle}>
                <ImProfile color='white' size='60' />   
              </Box>
              <Box sx={featuresDescriptionStyle}>{defaultTexts.customizableUserInterfacesText3}</Box>
            </Stack>
          </Box>
        </Stack>
      </Box>

      <Box sx={{ padding: '0px 12%' }}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='center'
          sx={{ width: '100%', height: '100px' }}
        >
          <CustomHomeDivider />
        </Stack>
      </Box>

      <Box sx={bannerBillingStyle}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems='center'
          justifyContent='space-around'
          spacing={ width >= constants.mdBreakpoint ? 12 : 4 }
          sx={{
            width: '100%',
            minHeight: width >= constants.mdBreakpoint ? '460px' : 'initial',
          }}
        >
          { width < constants.mdBreakpoint && <Box sx={bannerBillingLabel}>{defaultTexts.flexibleAndSecureBillingSystem}</Box> }
          <Box sx={bannerBillingDescription}>{defaultTexts.flexibleAndSecureBillingSystemText1}</Box>
          <Box>
            <Stack
              direction='column'
              alignItems='center'
              justifyContent='space-evenly'
              sx={{
                width: '100%',
                minHeight: width >= constants.mdBreakpoint ? '460px' : 'initial',
              }}
            >
              { width >= constants.mdBreakpoint && <Box sx={bannerBillingLabel}>{defaultTexts.flexibleAndSecureBillingSystem}</Box> }
              <Box sx={bannerBillingDescription}>{defaultTexts.flexibleAndSecureBillingSystemText2}</Box>
            </Stack>
          </Box>
        </Stack>
      </Box>

      <Box sx={{ padding: '0px 12%', position: 'relative' }} id='id_prices'>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='center'
          sx={{ width: '100%', height: '100px' }}
        >
          <CustomHomeDivider />
        </Stack>
        <Box sx={pricesLabel}>
          <Box>{defaultTexts.prices}</Box>        
        </Box>
      </Box>

      <Box sx={pricesWrapperStyle}>
        <Box sx={pricesLabelStyle}>{defaultTexts.openStackSolutionKit}</Box>
        {
          subscriptionsSliderData.length > 0 &&
          <CustomSlickSlider
            slides={subscriptionsSliderData}
            arrows={subscriptionSliderArrows}
            slidesToShow={subscriptionsSliderSlidesToShow}
            draggable={true}     
            centerMode={width < constants.mdBreakpoint ? true : false}
            sx={{ margin: width >= constants.mdBreakpoint ? '0px 50px' : '0px' }}
          />
        }
      </Box>
    </>
  )
}

export default HomeProductOpenStack